export default __webpack_public_path__ + "static/media/ic-de.8a619dd6.svg";